import type { AppMessage } from 'src/app/utils/in-app-comunication/types';

const SOURCE = 'hyrox-app';

export const sendMessage = (message: AppMessage) => {
  window.parent.postMessage({ source: SOURCE, ...message }, '*');
};

function isValidJSON(str: string): boolean {
  try {
    const result = JSON.parse(str);
    return typeof result === 'object' && result !== null;
  } catch (_e) {
    return false;
  }
}

export const onMessage = (handler: (msg: AppMessage) => void) => {
  const listener = (event: MessageEvent) => {
    if (typeof event.data === 'string' && isValidJSON(event.data)) {
      const receivedMessage = JSON.parse(event.data);
      if (receivedMessage.source === SOURCE) {
        handler(receivedMessage);
      }
    }
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
};
